/*
 * Copyright (C) Serfim TIC
 * All rights reserved
 */
import { Filter } from '../../../model/Filter';
import { Command } from '../../../model/Command';
import { ListController } from '../../ListController';

class GuaranteedRestoreTimeListController extends ListController {
    /** @ngInject */
    constructor(guaranteedRestoreTimeService, waitSpinnerService, $q, $state, $stateParams, $log, notificationService,
        configuration, domainService, filterService, dialogService, $scope) {
        super(configuration, notificationService, waitSpinnerService, $q, $state, $stateParams, $log);
        this.guaranteedRestoreTimeService = guaranteedRestoreTimeService;
        this.domainService = domainService;
        this.filterService = filterService;
        this.dialogService = dialogService;
        this.$scope = $scope;
        // mdDataTable doesn't support ES6 syntax with $ctrl variable in templates. That's why we must attach the reload
        // callback to the scope with an arrow function so as it can be called by this component with the correct 'this'
        // binding.
        this.$scope.reload = () => this.reload();
        this.$log.debug('Controller \'GuaranteedRestoreTimeList\' loaded');
    }

    $onInit() {
        super.$onInit();

        this.paging.sort = 'name';
        this.days = new Array(7);
        this.commands = [];
        this.initFilters();

        this.handleRestServiceCall(this.loadFilters(), () => {
            this.initCommands();
            this.reload();
        }).finally(() => {
            this.waitSpinnerService.visible = false;
        });
    }

    /**
     * Initializes the filters available at the top of the view.
     */
    initFilters() {
        this.domainFilter = Filter.equalFilterEmpty('domain.id', 'model.domain.domain', 'SELECT', []);

        this.filters.push(this.domainFilter, Filter.emptyLikeFilter('name', 'model.grt.name'));
    }

    /**
     * Initializes the commands available in the view header.
     */
    initCommands() {
        this.commands.push(
            Command.stateCommand('ui.grt.create', 'images/svg/add.svg', 'gmao.organization.grt.create'),
            Command.handlerCommand(undefined, 'images/svg/reset.svg', () => this.reload())
        );
    }

    /**
     * Loads data in filters.
     */
    loadFilters() {
        return this.getFilterDomains();
    }

    /**
     * Gets the list of domains.
     *
     * @return {Object[]} Promise providing an array of domains.
     */
    getFilterDomains() {
        return this.filterService.getFilterOptions(this.domainService, this.domainFilter, 'name');
    }

    /**
     * Reloads the list of GRTs.
     *
     * @return {Promise} A promise providing the list of GRTs.
     */
    reload() {
        return this.handleRestServiceCall(
            this.guaranteedRestoreTimeService.searchEntities({
                params: this.filterService.buildPagingParams(this.paging),
                data: this.filterService.buildFilters(this.filters)
            }),
            data => {
                this.model.data = data.content;
                this.model.totalElements = data.totalElements;
            }
        );
    }

    /**
     * Shows a confirmation dialog before deleting a GRT. If the dialog is confirmed, the GRT is deleted.
     *
     * @param {integer} GRT ID.
     * @return {Promise} A promise containing the confirmation result.
     */
    showDeleteConfirmationDialog(id) {
        return this.dialogService.showConfirmationDialogWithMessage('ui.grt.deleteconfirmation').then(
            confirmed => {
                if (confirmed) {
                    this.deleteGrt(id).finally(() => {
                        this.reload();
                    })
                }
                return confirmed;
            }
        );
    }

    /**
     * Deletes immediately a GRT without confirmation, and reloads the list of GRTs.
     *
     * @param {integer} GRT ID.
     */
    deleteGrt(id) {
        return this.handleRestServiceCall(this.guaranteedRestoreTimeService.deleteEntity(id), () => {
            this.notificationService.pushMessage('ui.grt.deleted', this.configuration.NOTIFIER_LEVEL_INFO);
        });
    }

    /**
     * Tells whether the given day is an active day in a GRT.
     *
     * @param {Object} grt A GRT object.
     * @param {integer} dayIndex Index of a day (1 -> monday, ..., 7 -> sunday).
     * @return {Boolean} True if the day is an active day.
     */
    isActionDay(grt, dayIndex) {
        return grt.actionDays.indexOf(dayIndex) !== -1;
    }
}

export const guaranteedRestoreTimeListComponent = {
    template: require('./guaranteedrestoretime-list.html'),
    controller: GuaranteedRestoreTimeListController
};



// WEBPACK FOOTER //
// ./src/main/front/scripts/module/organization/component/GuaranteedRestoreTimeList.js